import { App as AntdApp, Button, Card, Space, Tag, Typography } from 'antd'
import { SyncOutlined } from '@ant-design/icons'
import { useKnowledgeIndexStatus, useReindexPendingKnowledge } from '@/modules/knowledge/queries'

const { Text } = Typography

interface Props {
  // 补建向量索引仅 manager/admin 可用
  canManage: boolean
}

/** 向量索引状态：索引进度 + 向量库连通性 + embedding 模型，manager/admin 可触发补建 */
export default function KnowledgeIndexStatusBar({ canManage }: Props) {
  const { message } = AntdApp.useApp()
  const { data, isLoading } = useKnowledgeIndexStatus()
  const reindexMutation = useReindexPendingKnowledge()

  const handleReindex = () => {
    reindexMutation.mutate(undefined, {
      onSuccess: (result) => {
        if (result.failed > 0) {
          message.warning(`补建完成：成功 ${result.indexed} 条，失败 ${result.failed} 条`)
          return
        }
        message.success(`补建完成：本次成功索引 ${result.indexed} 条`)
      },
      onError: (err) =>
        message.error(err instanceof Error ? err.message : '补建向量索引失败，当前角色可能无此权限'),
    })
  }

  return (
    <Card size="small" loading={isLoading}>
      <Space wrap size="large">
        <Text>
          向量库：
          {data?.vector_store_healthy ? (
            <Tag color="green">已连通</Tag>
          ) : (
            <Tag color="red">未连通</Tag>
          )}
        </Text>
        <Text>
          Embedding：
          {data?.embedding_configured ? (
            <Text code>{`${data.embedding_model}（${data.embedding_dimension} 维）`}</Text>
          ) : (
            <Text type="secondary">未配置</Text>
          )}
        </Text>
        <Text>
          已索引 <Text strong>{data?.indexed ?? 0}</Text> / 共 {data?.total ?? 0} 条，待索引{' '}
          <Text strong type={data?.pending_index ? 'warning' : 'success'}>
            {data?.pending_index ?? 0}
          </Text>
        </Text>
        {canManage && (
          <Button
            size="small"
            icon={<SyncOutlined />}
            loading={reindexMutation.isPending}
            disabled={!data?.pending_index}
            onClick={handleReindex}
          >
            补建向量索引
          </Button>
        )}
      </Space>
    </Card>
  )
}
